import { createTheme } from '@mui/material';

/**
 * example for using custom palette color with typescript. See the usage of 'custom1' color on MuiSandboxPage, and
 * the definition of custom color in
 */
declare module '@mui/material/styles' {
  interface Palette {
    custom1: Palette['primary'];
  }

  interface PaletteOptions {
    custom1?: PaletteOptions['primary'];
  }
}
declare module '@mui/material/Button' {
  interface ButtonPropsColorOverrides {
    custom1: true;
  }
}

/**
 * theme definition
 */
export const theme = createTheme({
  typography: {
    fontFamily: "'Inter', sans-serif"
  },
  palette: {
    text: {
      primary: '#101010',
      secondary: '#646464',
      disabled: '#c0c0c0',
    },
    primary: {
      main: '#4C8BF5',
      light: '#E5ECFE'
    },
    // not used, just an example
    secondary: {
      main: '#00ff00',
    },
    error: {
      main: '#EA3829',
    },
    warning: {
      main: '#F68511',
    },
    info: {
      main: '#4C8BF5',
    },
    success: {
      main: '#2FB880',
    },
    // an example for custom color definition
    custom1: {
      main: '#E3D026',
      light: '#E9DB5D',
      dark: '#A29415',
      contrastText: '#242105',
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none',
        }
      }
    }
  }
});
